import React from 'react';
import { AlertOctagon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-14 bg-navy-950 text-center px-4" data-id="element-38">
      <div className="container mx-auto max-w-3xl" data-id="element-39">
        <div className="mb-10" data-id="element-40">
          <h2 className="text-2xl font-heading font-bold text-white mb-6 flex items-center justify-center gap-3" data-id="element-41">
            <AlertOctagon className="w-7 h-7 text-red-500" data-id="element-42" />
            Esto no es para todos
          </h2>

          <div className="space-y-3 text-lg text-slate-300" data-id="element-43">
            <p data-id="element-44">Si querés seguir igual… No hagas nada.</p>
            <p data-id="element-45">
              Si te conformás con apagar incendios… Este sistema no es para vos.
            </p>
            <p className="text-xl font-bold text-white pt-4" data-id="element-46">
              Pero si querés dar un salto real…
            </p>
            <p className="text-2xl font-bold text-gold-400" data-id="element-47">👉 Entonces sí.</p>
          </div>
        </div>

        <div className="bg-navy-900 p-6 md:p-8 rounded-2xl border border-navy-800 mb-8" data-id="element-48">
          <h3 className="text-xl font-bold text-white mb-4" data-id="element-49">
            ⚓ Este es el momento
          </h3>
          <p className="text-lg text-slate-300 mb-4" data-id="element-50">
            Porque el próximo charter va a llegar igual.
          </p>
          <p className="text-lg text-slate-300 mb-3" data-id="element-51">La única diferencia es:</p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6" data-id="element-52">
            <span className="bg-navy-950 px-4 py-2 rounded-lg border border-navy-700 text-slate-400" data-id="element-53">
              👉 Si va a ser otro caos…
            </span>
            <span className="bg-gold-500/10 px-4 py-2 rounded-lg border border-gold-500/30 text-white font-bold" data-id="element-54">
              👉 O el punto donde todo empieza a funcionar.
            </span>
          </div>

          <h3 className="text-2xl font-heading font-black text-white mb-4" data-id="element-55">
            🚀 Tomá control ahora
          </h3>
          <div className="space-y-2 text-slate-300 mb-6" data-id="element-56">
            <p data-id="element-57">No esperes a que los problemas se repitan otra vez.</p>
            <p data-id="element-58">No esperes a sentir el mismo estrés en el próximo servicio.</p>
            <p className="text-xl font-bold text-white mt-4" data-id="element-59">
              👉 Hacé el cambio ahora.
            </p>
          </div>

          <blockquote className="text-xl md:text-2xl font-heading font-bold text-gold-400 italic mb-8" data-id="element-60">
            💥 "No solo vas a ordenar tu trabajo…
            <br data-id="element-61" />
            vas a ordenar todo el barco."
          </blockquote>

          <div className="space-y-6" data-id="element-62">
            <p className="text-xl text-white font-medium" data-id="element-63">
              👉 Descargá Charter Command System™ y transformá tu forma de
              trabajar desde hoy.
            </p>

            <CTAButton data-id="element-64" />

            <p className="text-lg text-slate-400 mt-6" data-id="element-65">
              Convertite en el capitán que dirige un sistema…
              <br data-id="element-66" />
              <span className="text-white font-bold" data-id="element-67">
                No en el que sobrevive al caos.
              </span>
            </p>
          </div>
        </div>
      </div>
    </section>;
}